import { ICellRendererParams } from "@ag-grid-community/core";
import React from "react";
import { useIsFormDisabled } from "shared/components/form/FormStateProvider";
import { MaybernTableAddRemoveButtons } from "shared/components/table/maybern/MaybernTableAddRemoveButtons";

export type MaybernTableAddRemoveCellRendererProps = ICellRendererParams & {
  onClickAdd: () => void;
  onClickRemove: (index: number) => void;
};

export const MaybernTableAddRemoveCellRenderer: React.FC<
  MaybernTableAddRemoveCellRendererProps
> = ({ onClickAdd, onClickRemove, ...params }) => {
  const firstNode = params.api.getDisplayedRowAtIndex(0);
  const rowCount = params.api.getDisplayedRowCount();

  const showAddButton = firstNode?.id === params.node.id;
  const showRemoveButton = rowCount > 1;
  const isFormDisabled = useIsFormDisabled();
  return (
    <MaybernTableAddRemoveButtons
      isDisabled={isFormDisabled}
      params={params}
      showAddButton={showAddButton}
      showRemoveButton={showRemoveButton}
      onClickAdd={onClickAdd}
      onClickRemove={() => {
        onClickRemove(params.node.rowIndex!);
      }}
    />
  );
};
